export interface IPersonaArea {
  id_fk_persona: number;
  PERSONA: string;
}
export interface IDtoArea {
  id_departamento: number;
  DEPARTAMENTO: string;
  id_area: number;
  AREA: string;
  minutos5xcita: number;
  txtinfoweb: string;
  citapersonalizada: boolean;
  citaantelacion: number;
  PERSONAAREA: IPersonaArea[];
  videollamada: boolean;
}

export interface IHorarioDto {
  dia_semana: number;
  hora_inicio: string;
  hora_fin: string;
}
export interface IArea {
  id_area: number;
  AREA: string;
  minutos5xcita: number;
  txtinfoweb: string;
}
export interface IDtoAreaHorario {
  id_departamento: number;
  DEPARTAMENTO: string;
  citapersonalizada: boolean;
  citaantelacion: number;
  HORARIO: IHorarioDto[];
  AREAS: IArea[];
}

export class cArea {
  id_area: number;
  AREA: string;
  INFO: string;
  CARENCIA: string;
}

export class cDeparta {
  id_departamento: number;
  DEPARTAMENTO: string;
  HORARIO: string[];
  AREAS: cArea[];
}
